import { environment } from '@unified-ui/environments';

/**
 * Enum for token types stored in localStorage
 */
enum TOKEN_TYPE {
    ACCESS = 'accessToken',
    ID = 'idToken',
    REFRESH = 'refreshToken',
    ORG_ID = 'orgId',
    ORG_LIST = 'orgList',
    UI_ANALYTICS = 'uiAnalytics'
}

/**
 * Gets the current organization ID from localStorage
 * 
 * @returns {string} The current organization ID or empty string if not found
 */
export function getCurrentOrgId(): string {
    const clientId = environment.aws.amplify.Auth?.Cognito?.userPoolClientId || '';
    const prefix = `CognitoIdentityServiceProvider.${clientId}`;
    const subLastAuthUser = localStorage.getItem(`${prefix}.LastAuthUser`) ?? '';
    return localStorage.getItem(`${prefix}.${subLastAuthUser}.${TOKEN_TYPE.ORG_ID}`) ?? '';
}

/**
 * Retrieves the user org list from local storage.
 *
 * @returns {Record<string, string>} - The org list as an object where keys are orgIds and values are org names.
 */
export function getOrgList(): Record<string, string> {
    const clientId = environment.aws.amplify.Auth?.Cognito?.userPoolClientId || '';
    const prefix = `CognitoIdentityServiceProvider.${clientId}`;
    const subLastAuthUser = localStorage.getItem(`${prefix}.LastAuthUser`) ?? '';
    const orgListStr = localStorage.getItem(`${prefix}.${subLastAuthUser}.${TOKEN_TYPE.ORG_LIST}`) ?? '{}';
    return JSON.parse(orgListStr);
}

/**
 * Retrieves the organization name for a given orgId.
 *
 * @param {string} orgId - The organization ID.
 * @returns {string} - The organization name or empty string if not found.
 */
export function getOrgNameById(orgId: string): string {
    const orgList = getOrgList();
    return orgList[orgId] || '';
}

/**
 * Returns the name of the current organization.
 *
 * @returns {string} The name of the current organization as a string.
 */
export function getCurrentOrgName(): string {
    return getOrgNameById(getCurrentOrgId());
}